import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./common-filter-by.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./common-filter-by.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { SharedConstants } from "../../constants/shared-constants";
import { AflaCommonService } from "../../afla-common.service";
let CommonFilterByComponent = class CommonFilterByComponent {
    changeDetectorRef;
    aflaCommonService;
    filterByOptions = [];
    filterByChanged = new EventEmitter();
    filterTextChanged = new EventEmitter();
    errorMessageDisplay = new EventEmitter();
    pageName = "";
    initialFilterText = "";
    initialFilterColumn = "";
    branding;
    label = SharedConstants.FILTER_PREFIX;
    filterTextPlaceHolder = "";
    filterText = "";
    dropDownValue = "";
    dropDownPlaceHolder = SharedConstants.FILTER_BY_PLACEHOLDER;
    dropDownDefault = SharedConstants.FILTER_BY_DEFAULT;
    constructor(changeDetectorRef, aflaCommonService) {
        this.changeDetectorRef = changeDetectorRef;
        this.aflaCommonService = aflaCommonService;
        this.branding = aflaCommonService.branding;
    }
    ngOnInit() {
        this.filterText = this.initialFilterText;
        this.addFilterByDefault();
        this.initializePlaceHolder();
        if (this.initialFilterColumn) {
            this.dropDownDefault = this.initialFilterColumn;
            this.dropDownValue = this.initialFilterColumn;
        }
        else {
            this.dropDownValue = this.dropDownDefault;
        }
    }
    filterChanged($event) {
        this.dropDownValue = $event;
        this.filterByChanged.emit({
            text: this.filterText || "",
            // @ts-ignore
            column: this.dropDownValue
        });
        this.changeDetectorRef.markForCheck();
    }
    textChanged($event) {
        this.filterText = $event;
        if (this.dropDownValue === this.dropDownPlaceHolder) {
            this.errorMessageDisplay.emit(SharedConstants.NO_FILTER_SELECTED_MESSAGE);
            return;
        }
        // @ts-ignore
        this.filterTextChanged.emit({ text: $event, column: this.dropDownValue });
        this.changeDetectorRef.markForCheck();
    }
    addFilterByDefault() {
        if (this.filterByOptions && this.filterByOptions.indexOf(SharedConstants.FILTER_BY_DEFAULT) < 0)
            this.filterByOptions.unshift(SharedConstants.FILTER_BY_DEFAULT);
        if (this.filterByOptions && this.filterByOptions.indexOf(SharedConstants.EXCLUDE_HEADING_ACTIONS) < 0)
            this.filterByOptions.unshift(SharedConstants.EXCLUDE_HEADING_ACTIONS);
    }
    initializePlaceHolder() {
        if (this.pageName) {
            this.filterTextPlaceHolder = `Filter ${this.pageName.toLocaleLowerCase()}`;
        }
        else {
            this.filterTextPlaceHolder = SharedConstants.FILTER_ITEMS_PLACEHOLDER;
        }
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: AflaCommonService }
    ];
    static propDecorators = {
        filterByOptions: [{ type: Input }],
        filterByChanged: [{ type: Output }],
        filterTextChanged: [{ type: Output }],
        errorMessageDisplay: [{ type: Output }],
        pageName: [{ type: Input }],
        initialFilterText: [{ type: Input }],
        initialFilterColumn: [{ type: Input }]
    };
};
CommonFilterByComponent = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: "lib-common-filter-by",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CommonFilterByComponent);
export { CommonFilterByComponent };
